import React from 'react';
import { Link } from 'react-router-dom';
import { FileCheck, BookOpen } from 'lucide-react';
import { buildVerticalPath, type VerticalType } from '../../config/vertical';

interface LandingFooterSectionProps {
  vertical: VerticalType;
  footerClass: string;
  footerTextClass: string;
  footerMutedClass: string;
  headerBrandName: string;
  headerLogoSrc: string;
  isGreenhouse: boolean;
}

const LandingFooterSection: React.FC<LandingFooterSectionProps> = ({
  vertical,
  footerClass,
  footerTextClass,
  footerMutedClass,
  headerBrandName,
  headerLogoSrc,
  isGreenhouse,
}) => {
  return (
    <footer className={footerClass}>
      <div className="max-w-7xl mx-auto py-3 sm:py-4 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-0">
          <div className="flex items-center">
            <img
              src={headerLogoSrc}
              alt={`${headerBrandName} Logo`}
              className="h-8 w-8 object-contain"
            />
            <span className="font-brand ml-3 text-lg sm:text-xl font-bold text-vineyard-white">{headerBrandName}</span>
          </div>
          <div className="flex items-center flex-wrap justify-center gap-x-4 sm:gap-x-6 gap-y-2">
            <Link to={buildVerticalPath(vertical, '/resources')} className={`${footerTextClass} text-sm flex items-center`}>
              <FileCheck className="h-4 w-4 mr-1" />
              Resources
            </Link>
            <Link to={buildVerticalPath(vertical, '/blog')} className={`${footerTextClass} text-sm flex items-center`}>
              <BookOpen className="h-4 w-4 mr-1" />
              Blog
            </Link>
            <Link to={buildVerticalPath(vertical, '/about')} className={`${footerTextClass} text-sm flex items-center`}>
              About
            </Link>
            <Link to={buildVerticalPath(vertical, '/login')} className={`${isGreenhouse ? 'text-leaf-400 hover:text-leaf-300' : 'text-grape-300 hover:text-vineyard-white'} hover:underline text-sm font-medium`}>
              Sign In
            </Link>
            <Link to={buildVerticalPath(vertical, '/signup')} className={`${footerTextClass} text-sm`}>
              Register
            </Link>
            <Link to={buildVerticalPath(vertical, '/privacy')} className={`${footerTextClass} text-sm`}>
              Privacy Policy
            </Link>
            <Link to={buildVerticalPath(vertical, '/terms')} className={`${footerTextClass} text-sm`}>
              Terms of Service
            </Link>
          </div>
          <div className={`${footerMutedClass} text-xs sm:text-sm`}>
            © 2026 {headerBrandName}. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooterSection;
